import { all } from 'redux-saga/effects';

import { env } from '@/env';

import { registerOnAuthStateChanged } from '../bear-auth/onAuthStateChanged';
import { trackLoggedDemoUserSaga } from './trackLoggedDemoUser';

export function* saga() {
    yield registerOnAuthStateChanged();

    yield all([env.VITE_DEMO && trackLoggedDemoUserSaga()]);
}
